export default {
  routes: [
    {
      path: '/natural-newcomer',
      name: 'naturalNewcomer',
      meta: {
        title: '新人福利专区',
        pageId: 'O3152'
      },
      component: () =>
        import(/* webpackChunkName: "NaturalNewcomer" */ '../views/naturalNewcomer/index.vue')
    }
  ]
}
